export const MODAL_SIZE_VAR = {
  XXS: '400px',
  XS: '500px',
  S: '560px',
  M: '640px',
  L: '768px',
  XL: '1040px',
  XXL: '1280px',
} as const;

export type ModalSizeVar = (typeof MODAL_SIZE_VAR)[keyof typeof MODAL_SIZE_VAR];
